import React from 'react';

import ChatSettingsPane from 'llm/chat-library/shared/list-detail/ChatSettingsPane';
import UserUsageSummary from 'tenants/admin/ai-usage/UserUsageSummary';

export default function ChatSettingsUsageContent(): JSX.Element {
  return (
    <ChatSettingsPane header={{title: 'Usage'}}>
      <UserUsageSummary />
    </ChatSettingsPane>
  );
}
